<script setup lang="ts">
import { SphField, SphFieldGroup } from '@/components/base/field/'
import { SphButton } from '@/components/base/button'
import SphInput from '@/components/base/input'
import { useI18n } from '@/composables/i18n'

const { i18n } = useI18n()

defineOptions({
    compatConfig: {
        MODE: 3,
    },
})

const props = withDefaults(defineProps<{
    errors?: string[]
    loginUrl?: string
    passwordForgottenUrl?: string
}>(), {
    errors: () => [],
    loginUrl: '',
    passwordForgottenUrl: '',
})
</script>

<template>
    <form
        :action="props.loginUrl"
        method="post"
        novalidate
    >
        <header>
            <h2>{{ i18n.t('Anmelden') }}</h2>
            <p>
                {{ i18n.t('Willkommen zurück. Melden Sie sich bei Ihrer Verwaltungsplattform an.') }}
            </p>
        </header>

        <ul
            v-if="errors.length"
            class="errors"
        >
            <li
                v-for="message in errors"
                :key="message"
            >
                {{ message }}
            </li>
        </ul>

        <SphFieldGroup>
            <SphField
                v-slot="field"
                :label="i18n.t('E-Mail-Adresse')"
                :placeholder="i18n.t('name@organisation.de')"
                required
            >
                <SphInput
                    name="_username"
                    type="text"
                    v-bind="field"
                />
            </SphField>

            <SphField
                v-slot="field"
                :label="i18n.t('Passwort')"
                :placeholder="i18n.t('Ihr Passwort')"
                required
            >
                <SphInput
                    name="_password"
                    type="password"
                    v-bind="field"
                />
            </SphField>
        </SphFieldGroup>

        <div class="options">
            <a
                v-if="props.passwordForgottenUrl"
                :href="props.passwordForgottenUrl"
            >
                {{ i18n.t('Passwort vergessen?') }}
            </a>
        </div>

        <footer>
            <SphButton
                type="submit"
                variant="primary"
            >
                {{ i18n.t('Anmelden') }}
            </SphButton>
        </footer>
    </form>

    <div class="teaser">
        {{ i18n.t('Noch keinen uneto-Zugang?') }}
        <a
            href="mailto:kontakt@uneto.de?subject=Interesse%20an%20einer%20uneto-Demo"
            target="_blank"
        >
            {{ i18n.t('Demo anfragen') }}
        </a>
    </div>
</template>

<style scoped>
@reference "@/assets/styles/config.css";

form {
    @apply flex flex-col;
}

header {
    @apply mb-4;

    h2 {
        @apply text-2xl font-black mb-2;
    }

    p {
        @apply text-gray-500 leading-normal font-medium;
    }
}

.errors {
    @apply flex flex-col mb-4 text-red-700 font-semibold;
}

.options {
    @apply mt-6 flex flex-wrap items-center gap-x-6 gap-y-3 justify-between;
    color:#415F70;

    a {
        @apply block flex-none font-bold hover:underline whitespace-nowrap;
    }

}

footer {
    @apply mt-6;

    .sph-button {
        @apply w-full font-bold!;
    }
}

.teaser {
    @apply border-t-1 border-gray-300 pt-6 mt-6 text-center text-gray-500 font-medium;

    a {
        @apply inline-block font-bold hover:underline ml-2;
        color: #415F70;
    }
}
</style>
